import { Analytics } from '@segment/analytics-node';
import { Environment, loadEnv } from './env';
import * as hubspot from '@hubspot/api-client';

export type AppConfig = {
  env: Environment;
  minutesBetweenMeetings: number;
  minimumMinutesBeforeAppointment: number;
  publicUrl: string;
  appUrl: string;
  segment: () => Analytics;
  hubspot: () => hubspot.Client;
};

export enum Departments {
  Privat = 1,
  Bedrift = 2,
}

const appConfig: AppConfig = {
  minutesBetweenMeetings: 5,
  minimumMinutesBeforeAppointment: 300,
  publicUrl: 'https://www.allyjuss.no',
  appUrl: 'https://app.allyjuss.no',
  env: loadEnv(),
  segment: () => new Analytics({ writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY || '' }),
  hubspot: () => new hubspot.Client({ accessToken: appConfig.env.NEXT_PUBLIC_HUBSPOT_KEY }),
};

export default appConfig;

export const getNpsUrl = (bookingId: string) => `${appConfig.appUrl}/bookings/${bookingId}/nps`;
